// Module
var code = "<div class=\"va-imis-utility-loader\"> <span class=\"va-imis-utility-loader-icon\"></span> <span class=\"va-imis-utility-loader-text\"></span> </div>";
// Exports
export default code;